import { render, staticRenderFns } from "./IconPermanentDebt.vue?vue&type=template&id=f275571e&"
import script from "./IconPermanentDebt.vue?vue&type=script&lang=js&"
export * from "./IconPermanentDebt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports